/* global WC */
import TheForm from '@shared-vue-components/components/asiagoit-forms/TheForm.vue'
import {dateDeDE, dateEnUS, dateItIT, deDE, enUS, itIT, NConfigProvider} from 'naive-ui'
import {createApp, h} from 'vue'
import {getSeasonColors} from '~/default/scripts/utils/generic'

let lang

switch (WC.lang) {
	case 'en-GB':
		lang = 'en-US'
		break
	default:
		lang = WC.lang
		break
}

let locale, dateLocale

switch (lang) {
	case 'en-US':
		locale = enUS
		dateLocale = dateEnUS
		break
	case 'de-DE':
		locale = deDE
		dateLocale = dateDeDE
		break
	default:
		locale = itIT
		dateLocale = dateItIT
		break
}

const minisite = WC.PageVars.minisites?.at(0)
const colors = getSeasonColors()

if (minisite) {
	const app = createApp({
		setup() {
			return () =>
				h(
					NConfigProvider,
					{
						preflightStyleDisabled: true,
						locale,
						dateLocale,
						themeOverrides: {
							common: {
								primaryColor: colors.main,
								primaryColorHover: colors.lightest,
								primaryColorPressed: colors.lighter,
								primaryColorSuppl: colors.darker,
							},
						},
					},
					h(TheForm, {
						minisite,
						lang,
					})
				)
		},
	})

	document.addEventListener('cmsVueComponentsReady', () => {
		app.mount('[data-cms-vue-component="asiagoit-forms"]')
	})
}
